export default __webpack_public_path__ + "static/media/Izelle van Rensburg.31f9d430.jpeg";